var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_169_33",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 84,
    height: 84
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 8H8V92H92V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_169_33)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9993 8C73.1923 8 91.9993 26.8077 91.9993 49.9993C91.9993 73.193 73.1916 91.9993 49.9993 91.9993C26.807 92 8 73.193 8 49.9993C8 26.8077 26.807 8 49.9993 8ZM39.3886 35.5365L53.0584 60.4515C53.9648 61.3148 54.6553 62.4312 55.0039 63.73C56.0122 67.4911 53.7796 71.3582 50.0185 72.3665C46.258 73.3741 42.3902 71.1401 41.3819 67.3811C41.1167 66.3892 41.0771 65.3891 41.2302 64.4354L39.3886 35.5365ZM85.0082 52.3584C85.0082 55.4366 82.511 57.9338 79.4342 57.9338C76.3553 57.9338 73.8574 55.4366 73.8574 52.3584C73.8574 49.2809 76.3553 46.7837 79.4342 46.7837C82.511 46.783 85.0082 49.2809 85.0082 52.3584ZM14.9925 52.3584C14.9925 55.4366 17.4883 57.9338 20.5672 57.9338C23.6461 57.9338 26.1419 55.4366 26.1419 52.3584C26.1419 49.2809 23.6461 46.7837 20.5672 46.7837C17.489 46.783 14.9925 49.2809 14.9925 52.3584ZM25.1746 27.4756C22.998 29.6521 22.998 33.1836 25.1746 35.3602C27.3512 37.5367 30.8826 37.5367 33.0592 35.3602C35.2357 33.1836 35.2357 29.6521 33.0592 27.4756C30.8826 25.299 27.3512 25.299 25.1746 27.4756ZM50.0308 17.0815C53.1097 17.0815 55.6048 19.5773 55.6048 22.6563C55.6048 25.7331 53.1097 28.231 50.0308 28.231C46.9519 28.231 44.4561 25.7338 44.4561 22.6563C44.4567 19.5773 46.9519 17.0795 50.0308 17.0815ZM74.8247 27.4756C77.0033 29.6521 77.0033 33.1836 74.8268 35.3602C72.6502 37.5367 69.1187 37.5367 66.9422 35.3602C64.7643 33.1836 64.7643 29.6521 66.9422 27.4756C69.1187 25.299 72.6502 25.299 74.8247 27.4756Z",
    fill: "#1A003D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.0028a9a6d9ff7f41a6ece45271f8f044.svg";
export { ForwardRef as ReactComponent };